import { MainInner } from "@/styles/global";
import { ParagraphIngress, h1 } from "@/styles/typography";
import styled from "styled-components";

const Inner = styled(MainInner)<{ $bgImage?: string }>`
  height: ${({ $bgImage }) => ($bgImage ? "480px" : "auto")};
  padding-top: ${({ $bgImage }) => ($bgImage ? "100px" : "48px")};
  padding-bottom: 24px;

  @media print {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-bottom: ${({ $bgImage }) => ($bgImage ? "32px" : "40px")};
    padding-top: 100px;
  }
`;

const ContentWrapper = styled.div<{ $bgColor?: string; $hasImage: boolean }>`
  background-color: ${({ $bgColor }) => $bgColor};
  margin-top: auto;
  padding: ${({ $hasImage }) => ($hasImage ? "24px 16px" : "0")};
  border-radius: 4px;

  h1,
  p {
    color: ${({ $bgColor, theme }) =>
      $bgColor === "#534B93"
        ? theme.colors.coreLight
        : theme.colors.textHeading};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 450px;
    max-width: ${({ $hasImage }) => ($hasImage ? "900px" : "100%")};
    padding: ${({ $hasImage }) => ($hasImage ? "40px" : "0")};
  }
`;

const Title = styled(h1)``;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 820px;
  }
`;

const Ingress = styled(ParagraphIngress)``;

const FlexWrapper = styled.div<{ $hasIcon: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  height: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: ${({ $hasIcon }) => ($hasIcon ? "row-reverse" : "row")};
    justify-content: space-between;
    align-items: ${({ $hasIcon }) => ($hasIcon ? "center" : "flex-start")};
  }
`;

const Icon = styled.img`
  height: 100px;
  margin: 16px 0;
`;

const S = {
  Inner,
  ContentWrapper,
  Title,
  TextWrapper,
  Ingress,
  FlexWrapper,
  Icon,
};

export default S;
